// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography(fontFamily: string) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12,
          fontFamily
        }
      }
    }
  };
}
